const initialState = {
  businessInventoryList: [],
  businessInventoryListLoading: false,
  isDisabled: false,
  currentBarcodeNumber: [],
  categoriesByMenu: [],
  categoriesTotalCount: 0,
  categoriesChangeCount: 0,
  productsByCategory: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'GET_BUSINESS_INVENTORY_LIST':
      return { ...state, businessInventoryList: action.payload };
    case 'SET_BUSINESS_INVENTORY_LIST_LOADING':
      return { ...state, businessInventoryListLoading: action.payload };
    case 'SET_IS_DISABLED':
      return { ...state, isDisabled: action.payload };
    case 'SET_CURRENT_BARCODE_NUMBER':
      return { ...state, currentBarcodeNumber: action.payload };
    case 'GET_CATEGORIES_BY_MENU': {
      const categoriesData = action.payload.categories || action.payload || {};
      return {
        ...state,
        categoriesByMenu: Array.isArray(categoriesData)
          ? categoriesData
          : Object.values(categoriesData),
        categoriesTotalCount: action.payload.totalCount || 0,
        categoriesChangeCount: action.payload.changeCount || 0,
      };
    }
    case 'GET_PRODUCTS_BY_CATEGORY': {
      const productsData = action.payload.products || action.payload || {};
      return {
        ...state,
        productsByCategory: Array.isArray(productsData)
          ? productsData
          : Object.values(productsData),
      };
    }
    default:
      return state;
  }
};
